module.exports = "https://coursera_assets.s3.amazonaws.com/images/917652fa883145d45a34f05ffdedaf21.png";